import React from "react";
import Line from "../Line/Line";

const FooterReport = ({ date, color = "#C4161C" }) => {
    return (
        <div style={{ marginLeft: "5%", width: "90%" }}>
            <div
                style={{
                    display: "inline-block",
                    width: "90%",
                    fontStyle: "italic",
                }}
            >
                <p>Downloaded : {date}</p>
            </div>
            <div style={{ display: "inline-block", width: "10%" }}>{/* <img src="/assets/image/LOGO_EDUPRIME_2.png" width={"100%"} /> */}</div>
            <Line color={color} />
        </div>
    );
};

export default FooterReport;
